module.exports = __webpack_public_path__ + "media/images/pages/contributor_overview/imgBG_Licensing-729be958c7554c434533650aeec9a488.png";